import {http, onSuccess, onFail} from "./http";

export const commentsUpdate = (eventPassword, params) =>
    http.put(`/api/cp/event/${eventPassword}/question/messages`, params)
        .then(onSuccess, onFail);

export const commentsDelete = (eventPassword, params) =>
    http.delete(`/api/cp/event/${eventPassword}/comment/messages`, {params})
        .then(onSuccess, onFail);

export const commentSwitchToQuestion = (eventPassword, commentId) =>
    http.post(`/api/cp/event/${eventPassword}/comment/${commentId}/switchTo/question`)
        .then(onSuccess, onFail);
